export const DeliveryIconNextDaysV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M4.5 3L2.5 3" stroke="#229C8B" stroke-linecap="round" />
      <path d="M4.5 4.5L1.5 4.5" stroke="#077769" stroke-linecap="round" />
      <path d="M4.5 6L0.5 6" stroke="#229C8B" stroke-linecap="round" />
      <path d="M4.5 7.5H0.5" stroke="#077769" stroke-linecap="round" />
      <path d="M6.56113 10.4863H5.96094V13.6036H6.56113V10.4863Z" fill="#077769" />
      <path
        d="M6.52373 13.5998C7.30271 13.5998 7.93419 12.9028 7.93419 12.0431C7.93419 11.1833 7.30271 10.4863 6.52373 10.4863C5.74476 10.4863 5.11328 11.1833 5.11328 12.0431C5.11328 12.9028 5.74476 13.5998 6.52373 13.5998Z"
        fill="#085F54"
      />
      <path
        d="M6.01397 13.5998C6.79294 13.5998 7.42442 12.9028 7.42442 12.0431C7.42442 11.1833 6.79294 10.4863 6.01397 10.4863C5.235 10.4863 4.60352 11.1833 4.60352 12.0431C4.60352 12.9028 5.235 13.5998 6.01397 13.5998Z"
        fill="#077769"
      />
      <path
        d="M5.96217 12.532C6.20664 12.532 6.40482 12.3136 6.40482 12.0443C6.40482 11.775 6.20664 11.5566 5.96217 11.5566C5.71771 11.5566 5.51953 11.775 5.51953 12.0443C5.51953 12.3136 5.71771 12.532 5.96217 12.532Z"
        fill="white"
      />
      <path d="M12.9029 10.4863H12.3027V13.6036H12.9029V10.4863Z" fill="#077769" />
      <path
        d="M12.8655 13.5998C13.6445 13.5998 14.276 12.9028 14.276 12.0431C14.276 11.1833 13.6445 10.4863 12.8655 10.4863C12.0866 10.4863 11.4551 11.1833 11.4551 12.0431C11.4551 12.9028 12.0866 13.5998 12.8655 13.5998Z"
        fill="#085F54"
      />
      <path
        d="M12.3558 13.5998C13.1347 13.5998 13.7662 12.9028 13.7662 12.0431C13.7662 11.1833 13.1347 10.4863 12.3558 10.4863C11.5768 10.4863 10.9453 11.1833 10.9453 12.0431C10.9453 12.9028 11.5768 13.5998 12.3558 13.5998Z"
        fill="#077769"
      />
      <path
        d="M12.304 12.532C12.5484 12.532 12.7466 12.3136 12.7466 12.0443C12.7466 11.775 12.5484 11.5566 12.304 11.5566C12.0595 11.5566 11.8613 11.775 11.8613 12.0443C11.8613 12.3136 12.0595 12.532 12.304 12.532Z"
        fill="white"
      />
      <path
        d="M3.15527 5L0.155228 10.5C-0.344727 11.5 0.481264 12.0484 0.965165 12.0484H8.59476C9.07866 12.0484 9.46879 11.6583 9.46879 11.1744V6.48537C9.46879 6.00147 9.85891 5.61134 10.3428 5.61134H11.018C11.5019 5.61134 11.892 5.22122 11.892 4.73731C11.892 4.25341 11.5019 3.86328 11.018 3.86328L3.96517 3.86328C3.48126 3.86328 3.65495 3.86328 3.15527 5Z"
        fill="#077769"
      />
      <path
        d="M3.23074 3.37403C2.08415 5.84493 1.30089 8.02911 0.154297 10.5C0.154297 10.9839 0.480454 11.2595 0.964355 11.2595H8.65727C9.14117 11.2595 9.53129 10.8694 9.53129 10.3855V6.48457C9.53129 6.00067 9.92141 5.61054 10.4053 5.61054H11.0805C11.5644 5.61054 11.9548 4.75432 11.9546 3.37403C11.9546 2.89013 11.5644 2.5 11.0805 2.5H4.10476C3.62086 2.5 3.68846 2.5 3.23074 3.37403Z"
        fill="#229C8B"
      />
      <path
        d="M6.01118 4.14871C6.04778 4.16909 6.07651 4.20114 6.09277 4.23974C6.10904 4.27835 6.11191 4.32129 6.10093 4.36172L5.60292 6.18748H7.41993C7.45647 6.18748 7.49222 6.19816 7.52277 6.2182C7.55332 6.23824 7.57735 6.26678 7.59191 6.30029C7.60646 6.33381 7.6109 6.37085 7.60469 6.40686C7.59848 6.44287 7.58188 6.47628 7.55693 6.50298L4.93192 9.31549C4.90333 9.34619 4.86527 9.36642 4.82383 9.37293C4.78238 9.37944 4.73995 9.37187 4.70332 9.35143C4.66669 9.33098 4.63797 9.29884 4.62177 9.26015C4.60556 9.22145 4.6028 9.17844 4.61392 9.13799L5.11192 7.31248H3.29491C3.25837 7.31248 3.22263 7.3018 3.19207 7.28176C3.16152 7.26171 3.13749 7.23318 3.12294 7.19966C3.10838 7.16615 3.10394 7.12911 3.11015 7.0931C3.11637 7.05709 3.13297 7.02368 3.15791 6.99698L5.78292 4.18446C5.81152 4.15388 5.84952 4.13374 5.89089 4.12726C5.93226 4.12078 5.9746 4.12833 6.01118 4.14871Z"
        fill="white"
      />
      <path d="M11.7672 5.50586L13.4109 6.87567V12.081H9.10938V5.55319L11.7672 5.50586Z" fill="#FA4147" />
      <path d="M3.06504 10.4863H2.46484V13.6036H3.06504V10.4863Z" fill="#077769" />
      <path
        d="M3.02764 13.5998C3.80661 13.5998 4.43809 12.9028 4.43809 12.0431C4.43809 11.1833 3.80661 10.4863 3.02764 10.4863C2.24867 10.4863 1.61719 11.1833 1.61719 12.0431C1.61719 12.9028 2.24867 13.5998 3.02764 13.5998Z"
        fill="#085F54"
      />
      <path
        d="M2.51787 13.5998C3.29685 13.5998 3.92833 12.9028 3.92833 12.0431C3.92833 11.1833 3.29685 10.4863 2.51787 10.4863C1.7389 10.4863 1.10742 11.1833 1.10742 12.0431C1.10742 12.9028 1.7389 13.5998 2.51787 13.5998Z"
        fill="#077769"
      />
      <path
        d="M2.46589 12.6467C2.76851 12.6467 3.01382 12.3765 3.01382 12.0431C3.01382 11.7097 2.76851 11.4395 2.46589 11.4395C2.16328 11.4395 1.91797 11.7097 1.91797 12.0431C1.91797 12.3765 2.16328 12.6467 2.46589 12.6467Z"
        fill="white"
      />
      <path d="M9 5.50586H14.4582L16 7V11.3631L14.9506 12.081H9" fill="#229C8B" />
      <path
        d="M15.7971 6.87695H13.3457V12.0822H14.8856C15.5081 12.0822 16.0128 11.5779 16.0128 10.9554V7.69884C16.0128 7.47967 16.071 7.15092 15.7971 6.87695Z"
        fill="#077769"
      />
      <path
        d="M9.50991 2.5C8.90469 2.5 8.41406 2.99063 8.41406 3.59585V11.26L9.23595 10.986V6.60261C9.23595 5.99739 9.72658 5.50676 10.3318 5.50676H11.574C11.7945 5.50676 11.9756 5.33341 11.9756 5.12238V2.88438C11.9756 2.67335 11.7945 2.5 11.574 2.5H9.50991Z"
        fill="#077769"
      />
      <path d="M10.0982 10.5469H9.49805V13.6641H10.0982V10.5469Z" fill="#077769" />
      <path
        d="M10.0589 13.6604C10.8379 13.6604 11.4693 12.9634 11.4693 12.1036C11.4693 11.2439 10.8379 10.5469 10.0589 10.5469C9.27992 10.5469 8.64844 11.2439 8.64844 12.1036C8.64844 12.9634 9.27992 13.6604 10.0589 13.6604Z"
        fill="#085F54"
      />
      <path
        d="M9.55108 13.6604C10.33 13.6604 10.9615 12.9634 10.9615 12.1036C10.9615 11.2439 10.33 10.5469 9.55108 10.5469C8.77211 10.5469 8.14062 11.2439 8.14062 12.1036C8.14062 12.9634 8.77211 13.6604 9.55108 13.6604Z"
        fill="#077769"
      />
      <path
        d="M9.49714 12.7092C9.79976 12.7092 10.0451 12.439 10.0451 12.1056C10.0451 11.7722 9.79976 11.502 9.49714 11.502C9.19453 11.502 8.94922 11.7722 8.94922 12.1056C8.94922 12.439 9.19453 12.7092 9.49714 12.7092Z"
        fill="white"
      />
      <path
        d="M12.4231 7.59375C12.0231 7.59375 11.7579 8.00836 11.9256 8.37144L12.48 9.57164C12.5696 9.7656 12.7638 9.88979 12.9775 9.88979H16.0134L16.0294 7.59375H12.4231Z"
        fill="white"
      />
      <path d="M13.3457 9.89033V7.59375H16.0304V9.89033H13.3457Z" fill="#F4F4F4" />
    </svg>
  );
};
